var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0a1 1 0 011 1v22a1 1 0 01-1 1H1a1 1 0 01-1-1V5.4a1 1 0 01.293-.707l4.4-4.4A1 1 0 015.4 0zM6 2h-.186L2 5.814V22h2v-7a1 1 0 011-1h14a1 1 0 011 1v7h2V2h-4v7a1 1 0 01-1 1H7a1 1 0 01-1-1V2zm12 14H6v6h12v-6zM16 2H8v6h8V2zm-6 1a1 1 0 011 1v2a1 1 0 11-2 0V4a1 1 0 011-1z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconSave;